document.addEventListener("DOMContentLoaded", function () {
  // First, if customer is logged in, load favorites from Shopify metafield
  if (window.Shopify?.customer?.id) {
    fetchShopifyWishlist();
  }

  const buttons = document.querySelectorAll("ap-wishlistbutton");

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const wasActive = this.classList.contains("active");

      const product = {
        id: this.dataset.id,
        title: this.dataset.title,
        url: this.dataset.url,
        image: this.dataset.image,
        price: this.dataset.price,
      };

      let favorites =
        JSON.parse(localStorage.getItem("favoriteProducts")) || [];

      const index = favorites.findIndex((p) => p.id === product.id);

      if (!wasActive) {
        // Removing from favorites
        if (index !== -1) {
          favorites.splice(index, 1);
          localStorage.setItem(
            "favoriteProducts",
            JSON.stringify(favorites)
          );
          updateFavoritesPopup();
          if (window.Shopify?.customer?.id) {
            syncFavoritesToShopify(favorites);
          }
        }
      } else {
        // Adding to favorites
        if (index === -1) {
          favorites.push(product);
          localStorage.setItem(
            "favoriteProducts",
            JSON.stringify(favorites)
          );
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
        // document.body.style.overflow = "hidden";
        showFavoritesPopup();

        if (window.Shopify?.customer?.id) {
          syncFavoritesToShopify(favorites);
        }
      }
    });
  });

  // Wishlist icon toggle
  const wishlistIcon = document.querySelector(
    ".header__icon-wrapper.tap-area.wishlist_icon"
  );
  if (wishlistIcon) {
    wishlistIcon.addEventListener("click", function () {
      const popup = document.getElementById("favorite-popup");
      if (popup.style.display === "flex") {
        popup.style.display = "none";
        document.body.style.overflow = "";
      } else {
        showFavoritesPopup();
        // document.body.style.overflow = "hidden";
      }
    });
  }

  // Hide popup on other icon clicks
  const favoritePopup = document.getElementById("favorite-popup");
  [
    ".header__icon-wrapper.tap-area.cart_icon",
    ".header__icon-wrapper.tap-area.hd-pocket.hd-lap",
  ].forEach((selector) => {
    const icon = document.querySelector(selector);
    if (icon && favoritePopup) {
      icon.addEventListener("click", function () {
        if (favoritePopup.style.display === "flex") {
          favoritePopup.style.display = "none";
          document.body.style.overflow = "";
        }
      });
    }
  });

  // Close popup button
  const closeBtn = document.querySelector(".close-popup");
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      document.getElementById("favorite-popup").style.display = "none";
      document.body.style.overflow = "";
    });
  }
});

function showFavoritesPopup() {
  const popup = document.getElementById("favorite-popup");
  popup.style.display = "flex";
  updateFavoritesPopup();
}

function updateFavoritesPopup() {
  const list = document.getElementById("favorite-list");
  const favorites =
    JSON.parse(localStorage.getItem("favoriteProducts")) || [];

  list.innerHTML = "";

  if (favorites.length === 0) {
    list.innerHTML = "<li>No favorites yet.</li>";
  } else {
    favorites.forEach((item) => {
      const li = document.createElement("li");
      li.innerHTML = `
        <a href="${item.url}" style="display:flex; align-items:center; gap:10px; text-decoration:none; color:inherit;">
          <img src="${item.image}" alt="${item.title}" style="width:50px; height:auto; object-fit:contain;">
          <div>
            <div style="font-weight:500;">${item.title}</div>
            <div style="font-size:14px; color:#666;">${item.price || ""}</div>
          </div>
        </a>`;
      list.appendChild(li);
    });
  }
}

// ——— Shopify GraphQL Functions ——— 

const STOREFRONT_TOKEN = "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"; // Paste your token here
const SHOP_DOMAIN = window.location.hostname;

// Fetch wishlist from metafield and populate localStorage
async function fetchShopifyWishlist() {
  const query = `
    query {
      customer {
        metafield(namespace: "custom", key: "wishlist") {
          value
        }
      }
    }`;

  const response = await fetch(`https://${SHOP_DOMAIN}/api/2025-07/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
    },
    credentials: "include",
    body: JSON.stringify({ query }),
  });

  const data = await response.json();
  const value = data?.data?.customer?.metafield?.value;
  if (value) {
    const wishlist = JSON.parse(value);
    localStorage.setItem("favoriteProducts", JSON.stringify(wishlist));
    updateFavoritesPopup();
  }
}

// Sync favorites to Shopify metafields
async function syncFavoritesToShopify(favorites) {
  const mutation = `
    mutation updateCustomerMetafield($input: CustomerInput!) {
      customerUpdate(input: $input) {
        userErrors {
          message
          field
        }
      }
    }`;

  const variables = {
    input: {
      id: `gid://shopify/Customer/${Shopify.customer.id}`,
      metafields: [
        {
          namespace: "custom",
          key: "wishlist",
          type: "json",
          value: JSON.stringify(favorites),
        },
      ],
    },
  };

  const response = await fetch(`https://${SHOP_DOMAIN}/api/2025-07/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_TOKEN,
    },
    credentials: "include",
    body: JSON.stringify({ query: mutation, variables }),
  });

  const result = await response.json();
  if (result?.data?.customerUpdate?.userErrors?.length) {
    console.error("Shopify wishlist save errors:", result.data.customerUpdate.userErrors);
  } else {
    console.log("Wishlist synced to Shopify");
  }
}
